export default __webpack_public_path__ + "static/media/project1.27871653.jpg";